import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PWAThunk } from 'lib/core/data'
import { CartItem } from '../cart/types'
import { setCart } from '../cart'
import { triggerRemoveFromCart } from '../cartItemRemove/gtm/triggerRemoveFromCart'
import { Slice, CartItemUpdateSlice } from './types'

export const initialState: Slice = {}

interface ActionData {
  cartItem: CartItem
}

const getSlice = (slice: CartItemUpdateSlice): CartItemUpdateSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false
  })
}

const slice = createSlice({
  name: 'quote/cartItemUpdate',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { cartItem } = action.payload
      const { id: cartItemId } = cartItem
      const slice = getSlice(state[cartItemId])
      slice.isFetching = true
      state[cartItemId] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { cartItem } = action.payload
      const { id: cartItemId } = cartItem
      const slice = getSlice(state[cartItemId])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { cartItem } = action.payload
      const { id: cartItemId } = cartItem
      const slice = getSlice(state[cartItemId])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function cartItemUpdate (cartId: string, cartItem: CartItem, quantity: string): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    const { id: cartItemId } = cartItem
    dispatch(request({ cartItem }))
    try {
      const response = await magentoClient.getClient().quote.updateCartItems({
        cartId,
        cartItemId,
        quantity
      })

      const { data } = response
      const { updateCartItems } = data
      const { cart } = updateCartItems

      if (cart) {
        if (quantity === '0') {
          triggerRemoveFromCart({ cartItem })
        }
        dispatch(setCart({
          cartId,
          data: cart
        }))
        dispatch(success({ cartItem }))
      } else {
        dispatch(failure({ cartItem }))
      }

      return response
    } catch (e) {
      dispatch(failure({ cartItem }))
    }
  }
}
